import { createSelector } from 'reselect'
import getExperienceItems from '../view/items/getExperienceItems'

const getExperienceTicketCount = (experiences: Array<App.Checkout.ExperienceItem>) => {
  const res = experiences.flatMap(exp => exp.tickets).reduce<{ adults: number; children: number; infants: number }>((total, ticket) => {
    // TMP until experience ticket has occupant type
    const childMatch = /\b(child|children|childhood)\b/
    const infantMatch = /\b(infant)\b/

    if (childMatch.test(ticket.name.toLowerCase())) {
      total.children += ticket.count
    } else if (infantMatch.test(ticket.name.toLowerCase())) {
      total.infants += ticket.count
    } else {
      total.adults += ticket.count
    }

    return total
  }, { adults: 0, children: 0, infants: 0 })

  return res
}

const getInsuranceExperienceOccupants = createSelector(
  (state: App.State) => getExperienceItems(state),
  (experiences): App.Occupants => {
    const occupancies = getExperienceTicketCount(experiences)

    return {
      adults: occupancies.adults,
      children: occupancies.children,
      infants: occupancies.infants,
      childrenAge: [],
    }
  },
)

export default getInsuranceExperienceOccupants
